import { Col, Row, Form, Input, Button, Card } from "antd";
import { ImWhatsapp } from "react-icons/im";
import { ImageUrl } from "../../../config/helper";
import { Container } from "postcss";
import { FaArrowRightLong } from "react-icons/fa6";
import FancyVideo from "react-videojs-fancybox";
import { useNavigate } from "react-router-dom";
const { Meta } = Card;
const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const HomeComponent12 = () => {
  const cardData = [
    {
      title: "Black Luxury",
      // description:
      //   "Short description of the service and how the visitor will benefit from it.",
      description:
        "Our fleet of sleek black luxury vehicles is well-maintained and driven by highly trained chauffeurs.",
      imgSrc: ImageUrl("m1.png"),
    },
    {
      title: "Ultra Luxury",
      description:
        "Our exclusive collection of ultra-luxury cars offers unparalleled comfort, sophistication, and cutting-edge technology.",
      // description: "Short description of the service and how the visitor will benefit from it.",
      imgSrc: ImageUrl("m2.png"),
    },
    {
      title: "SUV Luxury",
      description:
        "Our premium SUV fleet is ideal for group travel, airport transfers, or exploring the city in luxurious comfort.",
      // description: "Short description of the service and how the visitor will benefit from it.",
      imgSrc: ImageUrl("m3.png"),
    },
  ];
  const navigate = useNavigate();
  return (
    <>
      <section className="py-5 home-modals-box">
        <Row justify={"center"}>
          <Col lg={18}>
            <Row justify="center" className="items-center">
              <Col xxl={24} md={24} sm={24} xs={24}>
                <h3 className="font-goldman text-white xldesktop:text-[65px] laptop:text-[46px] mobile:text-[32px] leading-[75px] text-center">
                  Our Models
                </h3>
              </Col>
            </Row>
            <Row justify={"center"} className="pt-6">
              <Col lg={23} md={23} sm={23} xs={23}>
                <Row justify={"space-around"} gutter={[16, 16]}>
                  {cardData.map((card, index) => (
                    <Col
                      key={index}
                      xxl={8}
                      xl={8}
                      lg={8}
                      md={8}
                      sm={12}
                      xs={24}
                    >
                      <Card
                        hoverable
                        cover={<img alt={card.title} src={card.imgSrc} />}
                      >
                        <Meta
                          title={card.title}
                          description={card.description}
                        />
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
            </Row>

            <div className="text-center mt-3">
              <button
                className="web-btn py-3 xl:px-12 px-3 text-sm max-xl:text-xs my-4 max-lg:hidden"
                // onClick={() => navigate("/signIn")}
                onClick={() => navigate("/contact")}
              >
                Book Now!
              </button>

            </div>
          </Col>
        </Row>
      </section>
    </>
  );
};

export default HomeComponent12;
